import { Outlet } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import BottomNav from './BottomNav'
import Header from './Header'
import Sidebar from './Sidebar'
import Topbar from './Topbar'
import OfflineBanner from './OfflineBanner'
import GlobalLoading from './GlobalLoading'
import { usePushNotifications } from '@/hooks/usePushNotifications'

const toastConfig = {
  duration: 3000,
  style: {
    background: '#1e293b',
    color: '#f1f5f9',
    borderRadius: '12px',
    padding: '12px 16px',
    fontSize: '14px'
  },
  success: { iconTheme: { primary: '#22C55E', secondary: '#fff' } },
  error:   { iconTheme: { primary: '#EF4444', secondary: '#fff' } }
} as const

const MainLayout = () => {
  usePushNotifications()

  return (
    <>
      {/* ── Desktop layout (lg+) ───────────────────────────────────── */}
      <div className="hidden lg:flex min-h-screen bg-gray-50">
        {/* Fixed sidebar */}
        <Sidebar />

        {/* Content area — offset for sidebar width */}
        <div className="flex flex-col flex-1 min-h-screen pl-64">
          <Topbar />
          <OfflineBanner />
          <main className="flex-1 overflow-y-auto p-6">
            <div className="max-w-7xl mx-auto">
              <div className="animate-page-enter">
                <Outlet />
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* ── Mobile layout (< lg) ───────────────────────────────────── */}
      <div className="flex lg:hidden flex-col min-h-screen bg-gray-50">
        <Header />
        <OfflineBanner />
        <main className="flex-1 overflow-y-auto scrollbar-hide pb-24 px-4 pt-4">
          <div className="animate-page-enter">
            <Outlet />
          </div>
        </main>
        <BottomNav />
      </div>

      <GlobalLoading />

      <Toaster position="top-right" toastOptions={toastConfig} />
    </>
  )
}

export default MainLayout
